<div class="eva-tabs-nav">
  @for (tab of tabs; track tab.value) {
    <button
      type="button"
      class="eva-tabs-nav__tab"
      [class.eva-tabs-nav__tab--active]="activeTab === tab.value"
      (click)="selectTab(tab.value)"
      [attr.aria-label]="tab.label"
      [attr.aria-selected]="activeTab === tab.value"
    >
      <i [class]="'pi ' + tab.icon"></i>
      <span class="eva-tabs-nav__tab-label">{{ tab.label }}</span>
      @if (tab.badge && tab.badge > 0) {
        <span class="eva-tabs-nav__badge" [class.eva-tabs-nav__badge--active]="activeTab === tab.value">
          {{ tab.badge > 99 ? "99+" : tab.badge }}
        </span>
      }
    </button>
  }
</div>
